import { initFederation } from '@angular-architects/native-federation';

// In production: Shell loads ./bootstrap via federation.
// In dev mode: uncomment the line below to run standalone.
initFederation()
  .then(() => import('./bootstrap-dev'))
  .catch(err => console.error('Federation init failed:', err));
